import { AlertTriangle } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog'
import { useTranslations } from '../providers/ContactServiceProvider'

export interface DefaultConfirmationDialogProps {
  open: boolean
  currentDefaultName: string
  newDefaultName: string
  onConfirm: () => void
  onCancel: () => void
}

export function DefaultConfirmationDialog({
  open,
  currentDefaultName,
  newDefaultName,
  onConfirm,
  onCancel,
}: DefaultConfirmationDialogProps) {
  const t = useTranslations()

  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900">
              <AlertTriangle className="h-5 w-5 text-amber-500" />
            </div>
            <AlertDialogTitle className="text-content-primary dark:text-dark-content-primary">
              {t.dialog.default.title}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            {t.dialog.default.message(currentDefaultName, newDefaultName)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t.dialog.default.cancel}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{t.dialog.default.confirm}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
